<script>
import moment from 'moment-timezone';
import Test from "@/view/pages/tutor/human-management/test.vue";
import BusinessCoefficientCreate from "@/view/pages/business-coefficient/BusinessCoefficientCreate.vue";
import {OneShiftTimeSlots, ThreeTimeSlots, TwoShiftTimeSlots} from "@/core/option/tutorOption";

export default {
  name: "ShiftScheduleManagement",
  components: {BusinessCoefficientCreate, Test},
  data() {
    return {
      week: null,
      workTimeFrame: 1,
      listWorkTimeFrame: [{label: '1 giờ', value: 1}, {label: '2 giờ', value: 2}, {label: '3 giờ', value: 3}],
      workScheduleOfAdmin:[{start: '09:15', end: '10:15', day: '21/08/2025',listAdmin:{adminNumber:2,title:'Nguyễn Thế Nguyên - 2222 \nNguyễn Thế Nguyên - 2222'}}]

      };
  },
  mounted() {
    const monday = moment().startOf('isoWeek');     // moment object
    this.week = monday.format('YYYY-MM-DD');
  },
  computed: {
    weekDays() {
      if (!this.week) return [];
      const labels = ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ nhật'];
      const monday = moment(this.week, 'YYYY-MM-DD', true).startOf('isoWeek');

      return labels.map((label, i) => {
        const d = monday.clone().add(i, 'days');
        return {
          label,
          display: d.format('DD/MM/YYYY'),
          raw: d.toDate(),
        };
      });
    },
    timeSlots() {
      if (this.workTimeFrame === 1) {
        return OneShiftTimeSlots
      }
      if (this.workTimeFrame === 2) {
        return TwoShiftTimeSlots
      }
      return ThreeTimeSlots
    },
    schedule(){
     return  this.timeSlots.map(slot => {
        return {
          timeStart: slot?.start,
          timeEnd: slot?.end,
          taskOfWeek: this.weekDays.map((day)=>{
            return this.workScheduleOfAdmin.find((scheduleOfAdmin)=>scheduleOfAdmin.start === slot?.start && scheduleOfAdmin?.end ===slot?.end && day?.display === scheduleOfAdmin?.day )
          })
        }
      })
    }
  },
  methods: {
    onOpen() {
    },
    close() {
    },
    handleSubmit() {
    },
    formatWeekRange() {
      if (!this.week) return '';
      const m = moment(this.week, "YYYY-MM-DD");
      const monday = m.clone().startOf("isoWeek");
      const sunday = m.clone().endOf("isoWeek");
      return `${monday.format("DD/MM/YYYY")} - ${sunday.format("DD/MM/YYYY")}`;
    },
  }
}
</script>

<template>
  <div class=" " style="background-color: white">
    <div class="p-4 d-flex align-items-center" style="border-bottom: #D6D5D5 1px solid">
      <p class="mb-0" style="font-size: 16px; font-weight:500">Quản lý lịch trực</p>
    </div>
    <!-- Header form -->
    <div class="row p-4">
      <div class="col-md-3">
        <label class="mb-1">Tuần làm việc</label>
        <el-date-picker
            v-model="week"
            type="week"
            placeholder="Chọn tuần"
            :format="formatWeekRange()"
            value-format="yyyy-MM-dd"
            :picker-options="{ firstDayOfWeek: 1 }"
            class="w-100"
        />
      </div>
      <div class="col-md-3">
        <label class="mb-1">Khung giờ làm việc</label>
        <el-select v-model="workTimeFrame" placeholder="Select" class="w-100">
          <el-option
              v-for="item in listWorkTimeFrame"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled">
          </el-option>
        </el-select>
      </div>
    </div>

    <!-- Bảng lịch -->
    <div class="px-4 pb-4">
      <div class="example-preview table-responsive p-4" style="max-height: 600px; overflow-y: auto;">
        <table class="table table-hover table-bordered table-vertical-center b-table">
          <thead>
          <tr class="text-center">
            <th style=" background: white;width: 150px">Khung giờ</th>
            <th v-for="(day,index) in weekDays" class="day-hdr" :id="`d${index}`" scope="col"
                style=" background: white;">
              <div style="text-align: center">
                {{ day.label }}
                <small style="display: block">{{ day.display }}</small>
              </div>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="shift in schedule" class="text-center">
            <td>{{ shift?.timeStart }} - {{ shift?.timeEnd }}</td>
            <td v-for="(task) in shift?.taskOfWeek">
               <span v-if="task?.listAdmin"  class=" badge badge-primary "  data-toggle="tooltip" data-placement="top"
                      style="	cursor: pointer " :title="task?.listAdmin?.title"> 2 Admin</span>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

</template>

<style scoped>
</style>
